import React from 'react'

// Clinic address line for the printed order label, shared by the labadmin and doctor labels.
//
// Doctors have no address of their own; the label API returns the clinic's as `clinicaddress`
// plus `cityname`. Either may be empty, so the parts are joined only when present, and the
// line is omitted entirely when both are - an empty "Address:" would waste a row on a sticker
// that has none to spare.
const Index = ({ order }) => {
    const address = [order.clinicaddress, order.cityname]
        .map((p) => (p == null ? '' : String(p).trim()))
        .filter((p) => p !== '')
        .join(', ');

    if (address === '') return null;
    return <p>Address: <b>{address}</b></p>;
}

export default Index
